module.exports = __webpack_public_path__ + "static/media/bg.9c604983.svg";